module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/lung-b5e1609aa7c4468a4bec91657f3622c1.png";